module.exports = __webpack_public_path__ + "img/bluesky3100_19.29c82b0c.jpg";